import React from 'react';
import PropTypes from 'prop-types';
import '../FormCheckbox/FormCheckbox.scss';

const FormTickBox = (props) => {
  const { name, id, input, autotestClass, children, meta } = props;
  return (
    <div className="form-checkbox-container">
      <span className="relative">
        <input
          className="form-checkbox-input"
          type="checkbox"
          name={name}
          id={id}
          {...input}
          checked={input.value}
        />
        <label
          className={`form-checkbox-label ${autotestClass}`}
          htmlFor={id}
        >{children}</label>
      </span>
      {meta && meta.touched && meta.error &&
      <div className="form-validation-message">{meta.error}</div>
      }
    </div>
  );
};

FormTickBox.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node,
  autotestClass: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object
};

export default FormTickBox;



/** WEBPACK FOOTER **
 ** ./src/components/form/FormTickBox/FormTickBox.js
 **/